import './App.css';
import Home from './Components/home/index';
import Aos from "aos"
import "aos/dist/aos.css"
import { useEffect } from 'react';

function App() {
  useEffect(() =>{
    Aos.init({
      offset: 120,
      delay: 50,
      easing: 'ease'
    });
}, [])
  return (
    <Home />
  );
}

export default App;
